import { Box, Dialog, DialogActions, DialogContent, Grid } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { CustomDialogTitle } from '../../../Common/Custom/CustomDialogTitle';
import { IDropDownOptions } from '../../../../Component/Common/Components/FormValidationInputs/AppSelectList';
import { FieldValues, useForm } from 'react-hook-form';
import { ScorecardVerificationValidationSchema } from './ScorecardVerificationValidationSchema';
import { yupResolver } from '@hookform/resolvers/yup';
import { BEEScorecardService } from '../../../../Component/Api/BEEScorecard/BEEScorecard';
import { SmallLoading } from '../../../../Component/Common/Components/Loading/IntermediateLoading';
import AppMultiSelect from '../../../../Component/Common/Components/FormValidationInputs/AppMultiSelect';
import AppInsertMultiSelection from '../../../../Component/Common/Components/FormValidationInputs/AppInsertMultiSelection';
import AppCheckbox from '../../../../Component/Common/Components/FormValidationInputs/AppCheckbox';
import { LoadingButton } from '@mui/lab';
import { UserService } from '../../../../Component/Api/User/UserService';
import { VerificationProcess } from '../../../../Component/Model/Dto/VerificationAgency/VerificationProcessTracker';
import { emptyGuid } from '../../../../Helpers/typescriptHelper';
import { VerificationProcessService } from '../../../../Component/Api/VerificationAgency/VerificationProcess/VerificationProcessService';
import { toast } from 'react-toastify';


interface IProps {
    showEmailProgressStatusModal: boolean;
    closeShowEmailProgressStatusModal: () => void;
    verificationProcessId: number;
    scorecardId: string;
}
export const ScorecardVerificationModal = (props: IProps) => {
    const [emailUsers, setEmailUsers] = useState<IDropDownOptions[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [additionalUserOptions, setAdditionalUserOptions] = useState<string[]>([]);
    const { control, watch, handleSubmit, formState: { isSubmitting }, reset, setValue } = useForm({
        mode: 'all',
        resolver: yupResolver(ScorecardVerificationValidationSchema)
    });

    const fetchData = async () => {
        setIsLoading(true);
        try {
            const users = await UserService.getAllUsers();
            const userList = users.data
                .filter(user => user.userType !== 'Admin')
                .map(({ username, name }) => ({ id: username, value: name }));

            setEmailUsers(userList);

        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        fetchData();
    }, [props.verificationProcessId]);

    const handleDataSubmit = async (data: FieldValues) => {


        const request: VerificationProcess.EmailVerificationProcessRequest = {
            attachSupportingDocs: data.includeDocuments,
            scorecardId: props.scorecardId,
            recordIDs: [
                props.verificationProcessId
            ],
            userMailDetails: [
                ...data.systemUsers.map((user: any) => ({
                    toUser: user,
                    toUserId: emptyGuid,
                    toEmailAddress: user,
                })),
                ...data.additionalUsers.map((email: any) => ({
                    toUser: email,
                    toUserId: emptyGuid,
                    toEmailAddress: email,
                }))
            ]
        }
        try {
            await VerificationProcessService.EmailVerificationProcess(request);
            toast.success('Email sent successfully');
        } catch (error) {
            console.log(error)
        }
    };


    return (
        <>
            <Dialog open={props.showEmailProgressStatusModal} onClose={props.closeShowEmailProgressStatusModal} aria-labelledby="form-dialog-title" maxWidth='md' fullWidth>
                <CustomDialogTitle id="customized-dialog-title" onClose={props.closeShowEmailProgressStatusModal}>
                        Email Users
                    </CustomDialogTitle>
                <DialogContent>
                    {isLoading ?
                        <SmallLoading />
                        :
                        <Grid container component="form" id='emailProgressForm' onSubmit={handleSubmit(handleDataSubmit)} sx={{ my: 2 }}>
                            <Grid item xs={12}>
                                <Box>
                                    <AppMultiSelect control={control} name="systemUsers" label="System Users" options={emailUsers} size="small" limit={emailUsers.length} />
                                </Box>
                                <Box mt={2}>
                                    <AppInsertMultiSelection control={control} name="additionalUsers" label="Additional Users" size="small" placeholderText='Please enter an email address...' options={additionalUserOptions} setOptions={setAdditionalUserOptions} />
                                </Box>
                                <Box mt={2}>
                                    <AppCheckbox control={control} name="includeDocuments" label="Add Supporting Documents" />
                                </Box>
                            </Grid>
                        </Grid>
                    }
                </DialogContent>
                <DialogActions>
                    <LoadingButton loading={isSubmitting} variant='contained' form='emailProgressForm' type="submit" color='primary'>
                        Send
                    </LoadingButton>
                </DialogActions>
            </Dialog>
        </>
    )
}

